import { useEffect,useState } from "react"
import axios from "axios"
import uuid from "react-uuid"
export default function AddCliente({setClientes}){
    const [error,setError]=useState(false)
    const [acierto,setAcierto]=useState(false)
    const [nombre,setNombre]=useState("")
    const [mensaje,setMensaje]=useState("")
    useEffect(()=>{
        
    },[])
    const Click=()=>{
        const nuevo={
            id:uuid(),
            nombre:nombre
        }
        let data=[]
        axios.get("https://www.asinova.es/webapi/api/Clientes")
            .then(res=>{
                data=res.data
                if (data.find(x=>x.nombre==nombre)!=null || nombre.replaceAll(" ","").length==0){
                    setError(true)
                    if (data.find(x=>x.nombre==nombre)!=null){
                        setMensaje("Cliente ya existente")
                    }
                    if (nombre.replaceAll(" ","").length==0){
                        setMensaje("Falta el Nombre")
                    }
                }
                else{
                    axios.post("https://www.asinova.es/webapi/api/Clientes",nuevo).then(()=>{
                        data.push(nuevo)
                        setClientes(data.sort((x,y)=>x.nombre.localeCompare(y.nombre)))
                        setAcierto(true)})
                }
            })
    }
    const onChange=(event)=>{
        setAcierto(false)
        setNombre(event.target.value)
    }
    return (
        <div>
            <h1 style={{textAlign:'center'}}>AÑADIR CLIENTE</h1>
            <div className="formulario-vertical"  style={error?null:{marginBottom:'1rem'}}>
                <input type="text" name="nombre" id="nombre" placeholder="Nombre" onChange={onChange}/>
            </div>
            {error?<p className='mensaje-error'><b>ERROR: {mensaje}</b></p>:acierto?<p className="aqua" style={{textAlign:'center'}}><b>Cliente añadido con éxito</b></p>:null}
            <a className='btn-form' style={{margin:'0 auto',width:'fit-content',display:'block'}} onClick={Click}>Enviar</a>
        </div>
    )
}